'use client';
import { ReactNode, createContext } from 'react';
import { ItemsConfig } from '@/shared/ui/for/types';

export const CategoryItemsConfigContext = createContext<ItemsConfig>({});

type Props = {
    value: ItemsConfig;
    children?: ReactNode;
};

export const CategoryItemsConfigProvider = ({ value, children }: Props) => {
    return (
        <CategoryItemsConfigContext.Provider value={value}>{children}</CategoryItemsConfigContext.Provider>
    );
};
